import { render } from "./Vendors.vue?vue&type=template&id=43a85c1a&scoped=true"
import script from "./Vendors.vue?vue&type=script&lang=js"
export * from "./Vendors.vue?vue&type=script&lang=js"

import "./Vendors.vue?vue&type=style&index=0&id=43a85c1a&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/www/releases/20260911022515/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43a85c1a"]])

export default __exports__